let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kyc3X")).then(() => parcelRequire('lu3aG'));